export default __webpack_public_path__ + "assets/http503-9e457e19ab4142b287edf79178202cb5.svg";